module.exports = __webpack_public_path__ + "static/media/srilankaRound.70312bb8.svg";